import React, {useCallback, useContext, useState} from 'react';
import {Popup, Input, toast, setOptions, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardWorkspaceAddName.css';
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardWorkspaceAddName({locale, dialog, Dialog, width, workspaceItemDialog, teamtalk, navigation}) {
    const {wsCall} = useContext(NetworkContext);
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonSave = () => {
        if (!name) {
            toast({message: locale.dashboardWorkspaceAddName.c, color: 'danger', display: 'bottom', duration: 3000});
        } else if (name) {
            setSaving(true);
            const item = {...workspaceItemDialog};
            item.name = name;
            item.teamtalk = (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null;
            item.tab = (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab;

            const message = {
                type: 'wss',
                path: item.type === 'file' ? 'workspace-file-generate' : 'workspace-item',
                action: 'put',
                data: item
            };
            wsCall(message);
        }
    }

    return (
        <Popup className="cs-dashboard-workspace-add-name-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardWorkspaceAddName'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-workspace-add-name-header-col">
                <div className="mbsc-row cs-dashboard-workspace-add-name-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-workspace-add-name-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-workspace-add-name-header-col mbsc-align-center" : "mbsc-col cs-dashboard-workspace-add-name-header-col"} >
                        <Button className="cs-dashboard-workspace-add-name-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardWorkspaceAddName.e}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-workspace-add-name-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-add-name-close-button" onClick={() => DialogClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-workspace-add-name-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <Input disabled={saving} inputStyle="underline" label={locale.dashboardWorkspaceAddName.b} labelStyle="floating" type="text" name="account" value={name} onChange={ev => setName(ev.target.value)} />
            {saving &&
                <Loading />
            }
            {!saving &&
                <div className="mbsc-button-group-justified cs-dashboard-workspace-add-name-nav-buttons">
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-add-name-nav-button" onClick={() => ButtonSave()} >
                        {locale.dashboardWorkspaceAddName.d}
                    </Button>
                </div>
            }
        </Popup>
    );
}

export default DashboardWorkspaceAddName;
